const WHATSAPP_LINK_SELECTOR = '[data-whatsapp-quote-link]';

function getSelectedOptions(root) {
  const selectedValues = [];

  root.querySelectorAll('input[name^="options["]:checked').forEach((input) => {
    if (input.value) selectedValues.push(input.value.trim());
  });

  root.querySelectorAll('select[name^="options["]').forEach((select) => {
    const value = select.value?.trim();
    if (value) selectedValues.push(value);
  });

  return selectedValues.join(' / ');
}

function getSelectedQuantity(root) {
  return root.querySelector('.quantity__input')?.value?.trim() || '';
}

function buildWhatsAppMessage(link) {
  const isDynamic = link.dataset.whatsappDynamic === 'true';
  const productRoot = isDynamic ? link.closest('product-info') : null;
  const productTitle = link.dataset.whatsappProductTitle || '';
  const productUrl = link.dataset.whatsappProductUrl || '';
  const context = link.dataset.whatsappContext || '';
  const variant = isDynamic ? getSelectedOptions(productRoot || document) : link.dataset.whatsappVariant || '';
  const quantity = isDynamic ? getSelectedQuantity(productRoot || document) : link.dataset.whatsappQuantity || '';
  const pageUrl = isDynamic ? window.location.href : link.dataset.whatsappPageUrl || window.location.href;
  const messageLines = ['Hola, quiero cotizar' + (productTitle ? ' este modelo.' : '.')];

  if (productTitle) messageLines.push('', `Producto: ${productTitle}`);
  if (variant) messageLines.push('', `Variante: ${variant}`);
  if (quantity) messageLines.push('', `Cantidad: ${quantity}`);
  if (context) messageLines.push('', `Origen: ${context}`);
  if (productUrl) messageLines.push('', `Enlace del producto: ${productUrl}`);
  if (pageUrl && pageUrl !== productUrl) messageLines.push('', `Página: ${pageUrl}`);

  return messageLines.join('\n');
}

function updateWhatsAppLink(link) {
  const phoneNumber = link.dataset.whatsappPhone || '50762168911';
  const text = encodeURIComponent(buildWhatsAppMessage(link));
  link.href = `https://wa.me/${phoneNumber}?text=${text}`;
}

function updateWhatsAppLinks(scope = document) {
  scope.querySelectorAll(WHATSAPP_LINK_SELECTOR).forEach(updateWhatsAppLink);
}

document.addEventListener('DOMContentLoaded', () => {
  updateWhatsAppLinks();
});

document.addEventListener('product-info:loaded', (event) => {
  updateWhatsAppLinks(event.target);
});

document.addEventListener('change', (event) => {
  const productRoot = event.target.closest('product-info');
  if (productRoot) updateWhatsAppLinks(productRoot);
});

document.addEventListener('input', (event) => {
  const productRoot = event.target.closest('product-info');
  if (productRoot) updateWhatsAppLinks(productRoot);
});

document.addEventListener('click', (event) => {
  const link = event.target.closest(WHATSAPP_LINK_SELECTOR);
  if (!link) return;

  updateWhatsAppLink(link);

  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'whatsapp_quote_click',
      tier: link.dataset.whatsappTier || 'secondary',
      context: link.dataset.whatsappContext || '',
      product: link.dataset.whatsappProductTitle || '',
    });
  }
});
